import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-letter-z', 'CircleLetterZ', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M10 8h4l-4 8h4"}]]);